module.exports = __webpack_public_path__ + "img/productBgImg24.e16e5e7c.png";